import { render, staticRenderFns } from "./contentWork.vue?vue&type=template&id=5495c150&scoped=true&"
import script from "./contentWork.vue?vue&type=script&lang=js&"
export * from "./contentWork.vue?vue&type=script&lang=js&"
import style0 from "./contentWork.vue?vue&type=style&index=0&id=5495c150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5495c150",
  null
  
)

export default component.exports